import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import loadingAnimation from '../assets/images/lottieJson/ic_loading.json';
import starLoadingAnimation from '../assets/images/lottieJson/star_loading.json';
import { color, fontSize } from '../common/themes';
import LottieImage from '../shared/LottieImage';
import ImageDisplay from './ImageDisplay';
import useResponsiveScale from './hooks/useResponsiveScale';

const useStyles = makeStyles(
	() => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
		fromOrg: {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			padding: '12px 16px',
			width: '100%',
			boxSizing: 'border-box',
		},
		avatar: {
			flexShrink: 0,
		},
		contentWrap: {
			margin: '0 12px',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			gap: 8,
			flex: 1,
			minWidth: 0,
		},
		botText: {
			fontSize: ({ fontScale }: any) => fontSize.sm * (fontScale || 1),
			color: color.$13,
			padding: 0,
			width: 'auto',
			maxWidth: '100%',
			wordWrap: 'break-word',
			wordBreak: 'normal',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			gap: 8,
			'& > img': {
				width: 36,
				height: 20,
			},
		},
		botTextLabel: {
			lineHeight: '18px',
			flex: '0 1 auto',
			whiteSpace: 'normal',
		},
		bubbleLoader: {
			flexShrink: 0,
		},
		statusLoader: {
			transform: 'translateY(-1px)',
		},
		bottomLoaderRow: {
			display: 'flex',
			justifyContent: 'flex-start',
			padding: '8px 24px',
			width: 'auto',
		},
	}),
	{
		name: 'Chat',
	}
);

const BotTyping = ({ orgData, text }: any) => {
	const { t } = useTranslation();
	const { fontScale } = useResponsiveScale();
	const classes = useStyles({ fontScale });
	const displayText = text || t('botTyping');

	return (
		<div className={classes.root}>
			<div className={classes.fromOrg}>
				<ImageDisplay
					alt="aibot"
					className={classes.avatar}
					style={{
						borderRadius: '50%',
					}}
					src={orgData.icon}
					width={44}
					height={44}
				/>
				<div className={classes.contentWrap}>
					<div className={classes.botText}>
						<span className={classes.botTextLabel}>{displayText}</span>
						<LottieImage
							animationData={starLoadingAnimation}
							height={24}
							width={24}
							className={`${classes.bubbleLoader} ${classes.statusLoader}`}
						/>
					</div>
				</div>
			</div>
			<div className={classes.bottomLoaderRow}>
				<LottieImage animationData={loadingAnimation} height={18} width={32} />
			</div>
		</div>
	);
};

export default BotTyping;
